import React from "react";
import { Doughnut } from "react-chartjs-2";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin globally
Chart.register(ChartDataLabels);

const DoughnutChartWidget = ({
  labels = [],
  data = [],
  colors = [],
  title = "",
  totalValue = null,
  legendData = [],
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "70%",
    aspectRatio: "1",
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: {
        color: "white",
        formatter: (value, context) => {
          const total = context.chart.data.datasets[0].data.reduce(
            (acc, val) => acc + val,
            0
          );
          const percentage = ((value / total) * 100).toFixed(0);
          return `${percentage}%`;
        },
        font: {
          weight: "bold",
          size: 14,
        },
      },
    },
  };

  return (

    <div className="cdashboard">
      <div className="cdashboard_top">
        <h4>{title}</h4>
        <p>{totalValue !== null && (<span className="text-lg font-bold text-gray-800">{totalValue}</span>)}</p>
      </div>
      <div className="cdashboard_middle">
        <div className="cdashboard_middle_box">
          <Doughnut data={chartData} options={options} plugins={[ChartDataLabels]} />
        </div>
      </div>
      <div className="cdashboard_bottom">
        <div className={`cdashboard_bottom_grid ${labels?.length === 2 ? "grid_2" : labels?.length === 4 ? "grid_4" : ""}`}>
          {legendData.map((item, idx) => (
            <div key={idx} className="cdashboard_bottom_grid_box">
              <h5 className="" style={{ color: colors[idx] }}>{item}</h5>
              <p>{labels[idx]}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DoughnutChartWidget;
